export function getDirectionalArrow(direction: 'ltr' | 'rtl'): string {
  return direction === 'rtl' ? '←' : '→';
}
